import React from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from '../../../../../../../common/react/utils/translations';

import { useGetMatchEventsQuery } from '../../../../../store/js/modules/api/content-api';

import { FixtureLinkButton } from './FixtureLinkButton';
import { FixtureMatchReportLink } from './FixtureMatchReportLink';

export const FixtureLinks = ({
    match,
    matchStatus,
    metadata = {},
    broadcastGuideUrl,
    reportLabel
}) => {
    // Parameters to get broadcaster match events for this round
    const params = {
        compseason: match?.compSeason?.id,
        round: match?.round?.roundNumber
    };

    const { shouldShowBroadcaster } = useGetMatchEventsQuery(params, {
        selectFromResult: ({ data }) => ({
            shouldShowBroadcaster: data?.content?.some(
                (matchEvent) =>
                    matchEvent?.channels?.length &&
                    matchEvent.contentReference.providerId === match.providerId
            )
        })
    });

    const renderUpcomingTicketLinks = () => {
        let ticketLink = {};

        if (metadata.ticket_link) {
            ticketLink = {
                icon: 'tickets-new',
                label: getTranslation('label.fixtures.buy-tickets'),
                href: metadata.ticket_link,
                target: '_blank'
            };

            return <FixtureLinkButton {...ticketLink} />;
        }
    };

    const renderUpcomingOrLiveTicketLinks = () => {
        let ticketLink = {};

        // only show a broadcast guide link if the match is assigned to a broadcaster match-event
        if (broadcastGuideUrl && shouldShowBroadcaster) {
            ticketLink = {
                icon: 'live-broadcast',
                label: getTranslation('label.fixtures.broadcastGuide'),
                href: broadcastGuideUrl,
                target: '_blank',
                theme:
                    matchStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE
                        ? 'live'
                        : 'alt'
            };

            return <FixtureLinkButton {...ticketLink} />;
        }
    };

    return (
        <>
            {matchStatus ===
                PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED && ( // check match status
                <FixtureMatchReportLink
                    match={match}
                    reportLabel={reportLabel}
                />
            )}

            {matchStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.UPCOMING &&
                renderUpcomingTicketLinks()}

            {(matchStatus ===
                PULSE.app.common.CONSTANTS.MATCH_STATUS.UPCOMING ||
                matchStatus === PULSE.app.common.CONSTANTS.MATCH_STATUS.LIVE) &&
                renderUpcomingOrLiveTicketLinks()}
        </>
    );
};

FixtureLinks.propTypes = {
    match: PropTypes.object,
    matchStatus: PropTypes.string,
    metadata: PropTypes.object,
    regionIsAus: PropTypes.bool,
    reportLabel: PropTypes.string,
    broadcastGuideUrl: PropTypes.string
};
